import { z } from "zod";
import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { codeSchema } from "../orgInvitation.schemas";
import { validateOrgInvitation } from "../utils/validateOrgInvitation";
import {
  INVITATION_SET,
  usePlatformDispatch,
} from "@platform//PlatformContext";

export function useSubmitCode() {
  const dispatch = usePlatformDispatch();

  const navigate = useNavigate();

  return useMutation({
    mutationFn: async (data: z.infer<typeof codeSchema>) => {
      return await validateOrgInvitation({ code: data.code, type: "code" });
    },
    onSuccess: (data) => {
      dispatch({ type: INVITATION_SET, payload: data });

      setTimeout(() => {
        navigate("/enroll");
      }, 2000);
    },
  });
}

export default useSubmitCode;
